"use strict";

module.exports = function (accumulator, order, product, component) {
  var size = component.product_size || component.size;

  if (size) {
    return accumulator + "-".concat(size);
  }

  return accumulator;
};